import { OverviewActiveUser } from './OverviewActiveUser'
import { withOverviewActiveUser } from './withOverviewActiveUser'

const ConnectedOverviewActiveUser = withOverviewActiveUser(OverviewActiveUser)
export { ConnectedOverviewActiveUser as OverviewActiveUser }
